<script setup>
import { onMounted, ref, watch } from "vue";
import { Head, Link, useForm } from "@inertiajs/vue3";
import VInputReadonlyWithLabel from "@/Shared/Form/VInputReadonlyWithLabel.vue";
import VDevider from "@/Shared/VDevider.vue";
import VTitleWithBackLink from "@/Shared/VTitleWithBackLink.vue";
import VHeaderButtonEdit from "@/Shared/HeaderButton/VButtonEdit.vue";
import VHeaderBreadcrumb from "@/Shared/VHeaderBreadcrumb.vue";

const props = defineProps({
    title: String,
    additional: Object,
});

const breadcrumbs = [
    {
        url: props.additional.urlIndex,
        label: "Survey Researcher",
    },
    {
        url: "#",
        label: "Detail Survey Researcher",
    },
];
</script>

<template>
    <Head>
        <title>{{ title }}</title>
    </Head>

    <div class="p-3">
        <VHeaderBreadcrumb :breadcrumbs="breadcrumbs" />

        <div class="card">
            <div class="card-body">
                <div class="d-flex justify-content-between">
                    <VTitleWithBackLink
                        :href="additional.urlIndex"
                        :filters="additional.filters ?? {}"
                    >
                        Detail Survey Researcher
                    </VTitleWithBackLink>
                    <div class="btn-wrapper">
                        <VHeaderButtonEdit
                            v-if="additional.canEdit"
                            :href="additional.urlEdit"
                        />
                    </div>
                </div>

                <VDevider />
                <div class="row">
                    <div class="col-lg-6">
                        <VInputReadonlyWithLabel
                            label="Code"
                            type="text"
                            :value="additional.surveyResearcher.code"
                        />
                        <VInputReadonlyWithLabel
                            label="Researcher"
                            type="text"
                            :value="additional.surveyResearcher.researcher.name"
                        />
                        <VInputReadonlyWithLabel
                            label="Survey Template"
                            type="text"
                            :value="
                                additional.surveyResearcher.survey_template.name
                            "
                        />
                        <VInputReadonlyWithLabel
                            label="URL"
                            type="text"
                            :value="additional.link"
                        />
                    </div>
                    <div class="col-lg-6 mt-5 mt-lg-0 text-center p-3">
                        <img
                            alt="QRCode Link"
                            :src="additional.qrcode"
                            style="width: 100%; max-width: 200px"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
